<div id="mail-confirm" class="flex flex-col" fusePerfectScrollbar>
  <div id="mail-confirm-form-wrapper" class="flex flex-col justify-center items-center">
    <div id="mail-confirm-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="logo">
        <mat-icon class="s-96">email</mat-icon>
      </div>

      <div i18n class="title">Подтвердите Ваш email адрес!</div>

      <div class="subtitle">
        <p i18n>На ваш адрес электронной почты ({{ email }}) было отправлено письмо для активации учетной записи</p>
        <p i18n
          >Проверьте ваш почтовый ящик и перейдите по ссылке указанной в письме, чтобы активировать учетную запись.</p
        >
      </div>

      <div class="message" *ngIf="userId">
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }"
          >Вернуться на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
